// src/router/routes.js

const Menu = () => import('@/views/menu/Menu');
const TakeAway = () => import('@/views/takeAway/TakeAway');
const Reserve = () => import('@/views/reserve/Reserve');
const Copilot = () => import('@/views/copilot/Copilot');
const Login = () => import('@/views/login/Login');
const IframeReserve = () => import('@/views/iframeReserve/IframeReserve');
const WidgetReserve = () => import('@/views/widgetReserve/WidgetReserve');
const Kiosk = () => import('@/views/kiosk/Kiosk');
const WeHost = () => import('@/views/weHost/WeHost.vue');
const HomePage = () => import('@/views/homePage/HomePage');
const EvensPage = () => import('@/views/events/EventsView.vue');

export const publicRoutes = [
	{
		path: '/',
		component: Reserve,
		name: 'Root',
		meta: { title: 'Reservas' },
	},
	{
		path: '/menu',
		component: Menu,
		name: 'Menu',
		meta: { title: 'Menú' },
	},
	{
		path: '/carta',
		component: Menu,
		name: 'Carta',
		meta: { title: 'Carta' },
	},
	{
		path: '/takeaway-delivery',
		component: TakeAway,
		name: 'TakeAway',
		meta: { title: 'TakeAway' },
	},
	{
		path: '/reservar',
		component: Reserve,
		name: 'Reserve',
		meta: { title: 'Reservas' },
	},
	{
		path: '/iframe-reservar',
		component: IframeReserve,
		name: 'IframeReserve',
	},
	{
		path: '/copilot',
		component: Copilot,
		name: 'Copilot',
		meta: { title: 'WECOPILOT' },
	},
	{
		path: '/login',
		component: Login,
		name: 'Login',
		meta: { title: 'Login' },
	},
	{
		path: '/widget',
		component: WidgetReserve,
		name: 'Widget',
		meta: { title: 'Widget Reservar' },
	},
	{
		path: '/kiosk',
		component: Kiosk,
		name: 'Kiosk',
		meta: { title: 'Kiosk' },
	},
	{
		path: '/wehost',
		component: WeHost,
		name: 'WeHost',
		meta: { title: 'WHost' },
	},
	{
		path: '/home',
		component: HomePage,
		name: 'Home',
		meta: { title: 'Home' },
	},
	{
		path: '/eventos',
		component: EvensPage,
		name: 'Events',
		meta: { title: 'Eventos' },
	},
];

export const privateRoutes = [];

// Catch-all route for handling non-existing routes
const catchAllRoute = {
	path: '/:pathMatch(.*)*',
	name: 'NotFound',
	redirect: '/reservar',
};

export const routes = [...publicRoutes, ...privateRoutes, catchAllRoute];
